// extracted by mini-css-extract-plugin
export default {"navbar":"styles_navbar__MbwUG","white_btn":"styles_white_btn__gmgAo"};